import _classCallCheck from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/createClass.js";
import { createUnsupportedError } from "./utils/unsupportedError.js";
/**
 * @summary SDK
 * @memberOf SDK
 * @description Defines an action that's a string literal, no validations or manipulations are performed
 */
var RawAction = /*#__PURE__*/function () {
  function RawAction(raw) {
    _classCallCheck(this, RawAction);
    this.raw = raw;
  }
  return _createClass(RawAction, [{
    key: "toString",
    value: function toString() {
      return this.raw;
    }
  }, {
    key: "toJson",
    value: function toJson() {
      return {
        error: createUnsupportedError("unsupported action ".concat(this.constructor.name))
      };
    }
  }]);
}();
export { RawAction };